import { LoginCallback } from '@okta/okta-react';
import { AuthSplash } from './AuthSplash';

function CallbackError({ error }: { error: Error }) {
  return (
    <AuthSplash
      tone="error"
      label="Sign-in failed"
      detail={error.message || 'Unknown error. Check Okta app configuration.'}
    />
  );
}

export function LoginCallbackRoute() {
  return (
    <LoginCallback
      loadingElement={<AuthSplash label="Completing sign-in" />}
      errorComponent={CallbackError}
    />
  );
}
